<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
    y="0px" :width="size" :height="size" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
    <path fill="#010101" opacity="1.000000" stroke="none" d="
  M64.000000,101.000000 
    C42.666672,101.000000 21.833342,101.000000 1.000008,101.000000 
    C1.000006,67.666679 1.000006,34.333351 1.000003,1.000022 
    C34.333317,1.000015 67.666634,1.000015 100.999969,1.000007 
    C100.999977,34.333309 100.999977,67.666618 100.999985,100.999969 
    C88.833336,101.000000 76.666664,101.000000 64.000000,101.000000 
  M70.636948,76.822571 
    C73.704285,76.822571 76.771622,76.822571 80.897369,76.822571 
    C72.696106,65.813873 65.190041,55.738358 57.576668,45.518795 
    C64.642563,37.896740 71.492950,30.507154 79.024734,22.382547 
    C71.624496,21.888845 69.835472,27.735275 66.327835,30.863043 
    C62.443180,34.326988 59.117748,38.418068 55.316185,42.484890 
    C50.620056,36.236958 46.392227,30.466261 41.970127,24.848480 
    C41.056660,23.688023 39.463604,22.452484 38.108696,22.360781 
    C33.545605,22.051939 28.948654,22.243265 23.329548,22.243265 
    C31.245872,32.873341 38.539558,42.667336 45.901646,52.553177 
    C38.488495,60.511387 31.258692,68.272774 24.028889,76.034157 
    C24.352415,76.502640 24.675943,76.971123 24.999470,77.439606 
    C26.894651,76.353485 29.146540,75.618546 30.622337,74.119537 
    C36.535980,68.112907 42.208900,61.869286 48.174641,55.495560 
    C52.623207,61.454357 56.913712,66.771103 60.695934,72.427704 
    C62.996025,75.867653 65.617661,77.606316 70.636948,76.822571 
  z" />
    <path fill="#E5E5E5" opacity="1.000000" stroke="none" d="
  M70.182411,76.822662 
    C65.617661,77.606316 62.996025,75.867653 60.695934,72.427704 
    C56.913712,66.771103 52.623207,61.454357 48.174641,55.495560 
    C42.208900,61.869286 36.535980,68.112907 30.622337,74.119537 
    C29.146540,75.618546 26.894651,76.353485 24.999470,77.439606 
    C24.675943,76.971123 24.352415,76.502640 24.028889,76.034157 
    C31.258692,68.272774 38.488495,60.511387 45.901646,52.553177 
    C38.539558,42.667336 31.245872,32.873341 23.329548,22.243265 
    C28.948654,22.243265 33.545605,22.051939 38.108696,22.360781 
    C39.463604,22.452484 41.056660,23.688023 41.970127,24.848480 
    C46.392227,30.466261 50.620056,36.236958 55.316185,42.484890 
    C59.117748,38.418068 62.443180,34.326988 66.327835,30.863043 
    C69.835472,27.735275 71.624496,21.888845 79.024734,22.382547 
    C71.492950,30.507154 64.642563,37.896740 57.576668,45.518795 
    C65.190041,55.738358 72.696106,65.813873 80.897369,76.822571 
    C76.771622,76.822571 73.704285,76.822571 70.182411,76.822662 
  M55.884686,59.605717 
    C58.174408,62.661007 60.752895,65.545830 62.682117,68.813934 
    C65.198395,73.076515 68.525948,73.792740 73.258820,72.362625 
    C62.609795,58.140011 52.031933,44.319473 41.848377,30.214260 
    C38.994366,26.261179 35.976921,25.151047 31.179110,26.639488 
    C39.369026,37.588837 47.397945,48.322948 55.884686,59.605717 
  z" />
    <path fill="#0D0D0D" opacity="1.000000" stroke="none" d="
  M55.655777,59.331390 
    C47.397945,48.322948 39.369026,37.588837 31.179110,26.639488 
    C35.976921,25.151047 38.994366,26.261179 41.848377,30.214260 
    C52.031933,44.319473 62.609795,58.140011 73.258820,72.362625 
    C68.525948,73.792740 65.198395,73.076515 62.682117,68.813934 
    C60.752895,65.545830 58.174408,62.661007 55.655777,59.331390 
  z" />
  </svg>
</template>

<script>
export default {
  props: {
    size: { type: String }
  }
}
</script>